import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import vueHeadful from "vue-headful";
import LoadScript from "vue-plugin-load-script";
import axios from "axios";
import VueAxios from "vue-axios";
import AOS from "aos";
import "aos/dist/aos.css";
import VueLodash from "vue-lodash";
import lodash from "lodash";
Vue.use(VueAxios, axios);
Vue.use(LoadScript);
Vue.component("vue-headful", vueHeadful);
Vue.use(Buefy);
Vue.config.productionTip = false;
Vue.use(VueLodash, { lodash: lodash });

new Vue({
  created() {
    AOS.init({ disable: "phone" });
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
